<ngx-zero-state>
	<p zero-state-title>{{getTitle() | async}}</p>
	<p zero-state-subtext>{{getSubText() | async}}</p>
	<div zero-state-body>
		@if (showDefaultButtons()) {
			<div>
				@if (canInvite) {
					<button class="secondary-btn" (click)="openInvite.emit()">{{'common_invite' | translate}}</button>
				}
				<button (click)="createFolder.emit()" data-cy="create-course" class="primary-btn">{{'folders_view-create_button' | translate}}</button>
			</div>
		}

		@if (!showDefaultButtons() && (showFilterAllButton$ | async)) {
			<div>
				<button class="filter-all-button secondary-btn" (click)="filterToAll()" translate="filter-by-all"></button>
			</div>
		}
	</div>

	@if (showGraphic()) {
		<div zero-state-graphic-bottom>
			<img [src]="activeBrandService.getImage('astronaut-astroid.svg')" alt="No Results">
		</div>
	}
</ngx-zero-state>
